import {IServices, IServicesListItem} from '@/entity/services/services.types';
import { ServiceStore } from '@/store/modules/Services';
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export class serviceswithQuillwortMix extends Vue {
    get serviceswithQuillwort():IServices | null {
        return ServiceStore.service;
    }
    get services():IServicesListItem | null {
        return ServiceStore.services;
    }

}

